import {mixins} from "../app/mixin";

mixins.push({
    el: '#sideMenu',
    data() {
        return {
            isSideMenuOpen: false,
            isSideMenuIconShown: false,
            activeMenuItem: 0,
            showMoveTopIcon: false
        }
    },
    methods: {
        toggleMenu() {
            this.isSideMenuOpen = !this.isSideMenuOpen;

            this.checkSideMenuOpen();
        }, closeMenu() {
            this.isSideMenuOpen = false;

            this.checkSideMenuOpen();
        }, checkSideMenuOpen() {
            //TODO Saçma
            const element = document.getElementById("__layoutWrapper");
            const baseElement = document.getElementById('__baseLayoutWrapper');

            if (this.isSideMenuOpen) {
                element.classList.remove("layoutWrapper");
                baseElement.classList.add('hide-important');
            } else {
                element.classList.add("layoutWrapper");
                baseElement.classList.remove('hide-important');
            }
        }, setActiveMenuItem(menuId) {
            if (menuId !== this.activeMenuItem && menuId < 4) {
                this.activeMenuItem = menuId
            }
        },
        handleScroll() {
            this.showMoveTopIcon = window.scrollY > 0;
        },
        moveToTop() {
            window.scrollTo(window.scrollX, 0);
        }
    },
    created() {
        window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    },
});